import { Trans } from '@lingui/macro';
import React, { FC, useContext } from 'react'
import Modal from 'react-modal';
import AlumniService from '../../../services/AlumniService';
import { Context } from '../../..';


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
    data: any;
    date: string;
    setFix: (value: boolean) => void;
}

export const VideoModal: FC<ModalProps> = props => {
    const { toggle, setToggle, data, date, setFix } = props;
    const { store } = useContext(Context);
    var htmlObject = document.createElement('div');
    htmlObject.innerHTML = data['text'];

    // const [images, setImages] = useState<any[]>([]);

    const onRequestClose = () => {
        setToggle(false);
    };

    const setModerate = async () => {
        await AlumniService.updateVideo(data['id'], { moderated: !data['moderated'] })
        setFix(true)
        setToggle(false)
    }

    // const getImages = () => {
    //     let imgMass = []
    //     if (!isEmpty(data)) {
    //         for (let i = 1; i < 10; i++) {
    //             if (data[`image${i}`]) {
    //                 imgMass.push(data[`image${i}`]);
    //             }
    //         };
    //     }
    //     setImages(imgMass);
    // };

    // useEffect(() => {
    //     getImages();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [data]);


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
                {store.user.is_superuser ?
                    <div className="col text-end">
                        <button type='button' className={'btn' + (data['moderated'] ? ' btn-warning' : ' btn-success')} onClick={() => setModerate()}>
                            {data['moderated']
                                ?
                                <>
                                    <span className="icon close" />
                                    <Trans>Remove from approval</Trans>
                                </>

                                :
                                <>
                                    <span className="icon check" />
                                    <Trans>Approve</Trans>
                                </>
                            }
                        </button>
                    </div>
                    : null}
            </div>
            <form className="Modal__Body">
                <div className="form-group">
                    <iframe className='w-100' src={data['video_link']} height="600" title={`video_${data['id']}`}></iframe>
                    <h3 className="event-header">{data['header']}</h3>
                    <hr />
                    <div className="row">
                        <div className="col-9">
                            <div className="h5 event-header">Выпускник: {data['alumni_fio']}</div>
                            <div className='mb-2'>Год выпуска: {data['issue_year']}</div>
                            <div className='mb-2'>Школа: {data['school']}</div>
                            <div>Муниципальное образование: {data['municipality']}</div>
                        </div>
                        <div className="col-3">
                            <div className="mb-2 text-end">Автор: {data['author']}</div>
                            <div className="text-end"><Trans>Publication date</Trans>: {date}</div>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    );
};